module.exports = __webpack_public_path__ + "img/tutor-banner-hk.11cedbe1.jpg";